import ApiService from '@/services/core/api.service'

const ReportService = {
  async getTransactionHistories (query) {
    return ApiService.get(`disbursement/reports/transaction-histories?${query}`)
  }
}

export default ReportService
